export const environment = {
  production: true,
  apiUrl: 'https://prod.osakaconsorcios.ar',
  publicUrl: 'https://c.osakaconsorcios.ar',
  firebaseConfig: {
    apiKey: "AIzaSyBPvgewwTmSbjbSG_97tVjfO6Uh2jjxVVc",
    authDomain: "frontosaka-aed5a.firebaseapp.com",
    projectId: "frontosaka-aed5a",
    storageBucket: "frontosaka-aed5a.firebasestorage.app",
    messagingSenderId: "8695264044",
    appId: "1:8695264044:web:dea344bb8835ccf3577289"
  }
};
